import type { QueryClient } from '@tanstack/react-query';
import { notFound, redirect } from '@tanstack/react-router';
import { getVisualizationViewsQueryOptions } from '@/features/views/queries/useVisualizationsView';
import {
  getLastVisitedMainVisualization,
  getLastVisitedView,
} from './lastVisitedVisualizationView';
import { visualizationTypeToUrlSegment } from './visualizationTypeToUrlSegment';

export async function redirectToLastLoopVisualization({
  org,
  queryClient,
  loopId,
}: {
  org: string;
  queryClient: QueryClient;
  loopId: number;
}): Promise<void> {
  if (!loopId) throw notFound();

  const lastVisited = getLastVisitedView(loopId);

  if (lastVisited?.type === 'view') {
    const views = await queryClient.ensureQueryData(getVisualizationViewsQueryOptions({ loopId }));
    if (views.some((v) => v.viewId === lastVisited.id)) {
      throw redirect({
        to: `/org/$org/loop/$loopId/visualizations/view/$viewId`,
        params: { org, loopId, viewId: lastVisited.id },
        replace: true,
      });
    }
  }

  const mainVisualization = getLastVisitedMainVisualization(loopId) ?? 'table';
  throw redirect({
    to: `/org/$org/loop/$loopId/visualizations/main/${visualizationTypeToUrlSegment(mainVisualization)}`,
    params: { org, loopId },
    replace: true,
  });
}
